import type { TaskLanguage, TaskLanguageMap } from '@app/features/project/screens/Tasks/pages/NewTask/types';

const mapTaskLanguages = (taskLanguageMap: TaskLanguage | null): TaskLanguageMap[] => {
    if (!taskLanguageMap) {
        return [];
    }

    return Object.values(taskLanguageMap).map((task) => ({
        langName: task.name,
        langId: +task.lang_id,
    }));
};

export default mapTaskLanguages;
